import { Box, CircularProgress } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import * as React from 'react';
import { DOSE_REPORT_PATH, getDoseReportValidationRules } from '../../api/dose-reports';
import { RadiationDoseForm } from '../../forms/documents/RadiationDoseForm';

export const RadiationDosesPage: React.FunctionComponent = () => {
    const { data: rules } = useQuery([DOSE_REPORT_PATH, 'rules'], () => getDoseReportValidationRules({}));
    if (!rules)
        return (
            <Box
                sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
                <CircularProgress />
            </Box>
        );
    return <RadiationDoseForm rules={rules} />;
};
